import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "生産中止",
  "Spare part list": "スペアパーツリスト",
  "Download Excel": "エクセルのダウンロード",
  "Recent search list": "最近の検索リスト",
  "No data": "データなし",
  "spare part": "スペアパーツ",
  "none": "なし",
  "no value": "ノーバリュー",
  "No results found": "結果は見つかりませんでした",
  "Spare parts for": "スペアパーツ",
  "Could not load cumulated data": "累積データをロードできなかった",
  "commissioning part": "コミッショニングパート",
  "wear part": "消耗部品",
  "Search": "検索",
  "Tk": "Tk",
  "Spare part number": "予備品番",
  "drawing": "図面",
  "Products for": "製品",
  "Available": "利用可能",
  "MM": "MM",
  "The entered order code is invalid": "入力された注文コードが無効です。",
  "Recommended": "おすすめ",
  "No data available for the entered search parameters": "入力された検索パラメータに該当するデータがありません",
  "Search spare parts": "スペアパーツ検索",
  "Order code / product root / serial number": "注文コード／製品ルート／シリアル番号",
  "Characteristic": "特徴",
  "Please enter an order code": "注文コードを入力してください",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "品質と安全性に関して、エンドレスハウザーは純正部品の使用を強く推奨しています。本装置の保守および修理は、有資格者のみが行うことができます。デバイス・ドキュメントの適用規格および法的要件、ならびにあらゆる証明書を遵守しなければならない！",
  "Maintenance advice": "メンテナンスに関するアドバイス",
  "Mo.": "モ",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "スペアパーツはどの製品に使用できますか？スペアパーツの注文コード（71002865やXPD0024など）を入力すると、このスペアパーツが使用できる関連機器が表示されます。",
  "tool": "工具",
  "Production numbers": "生産台数",
  "New alternative": "新しい選択肢",
  "There are no items selected. Please use the checkboxes to make your selection": "選択されている項目はありません。チェックボックスで選択してください。",
  "Service segmentation": "サービス・セグメンテーション",
  "Seg": "セグ",
  "Valid": "有効",
  "Pos": "ポス",
  "Value": "価値",
  "service segmentation 2": "基本的な知識を必要とする部分。E+H基礎トレーニングに合格することが前提条件となる。",
  "Phase out date": "段階的廃止日",
  "service segmentation 1": "基本的な知識を必要とする部分。",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "私の製品にはどのスペアパーツがありますか？注文コード（例：FTC260-AA2A1またはPMC51-BA21JB1CGBTDJB）または製品ID（例：FTC260または83F50）を入力すると、該当するスペアパーツが表示されます。",
  "Set filter": "フィルタを設定する",
  "Search date": "検索日",
  "Group": "グループ",
  "Warning": "警告",
  "Description": "説明",
  "Cancel": "キャンセル",
  "service segmentation 4": "工場で修理するための部品。専門知識は必須。",
  "service segmentation 3": "専門的な知識を必要とする部品。E+Hの上級トレーニングに合格することが前提条件となる。",
  "Drawing Position Number": "図面ポジション番号",
  "Spare parts search": "スペアパーツ検索",
  "Confirm": "確認",
  "Ordercode too short": "オーダーコードが短すぎる",
  "Product status": "製品ステータス",
  "Open": "オープン",
  "Clear": "クリア",
  "PDF file with assembly instructions": "組み立て説明書付きPDFファイル",
  "Search products": "製品検索",
  "Export": "輸出",
  "Production date": "製作日",
  "Order stop": "オーダーストップ",
  "Calibration until": "キャリブレーション",
  "PDF file with compatibility information": "互換性情報のPDFファイル",
  "Add selection to cart": "カートに入れる",
  "Mounting advices": "取り付けに関するアドバイス",
  "Recommended parts only": "推奨部品のみ",
  "not applicable": "該当なし",
  "accessories": "アクセサリー",
  "Cumulative spare parts list": "累積スペアパーツリスト",
  "YYYY": "年",
  "Title": "タイトル",
  "Error": "エラー",
  "Ordercode too long": "オーダーコードが長すぎる",
  "Functions": "機能",
  "Rec": "レック",
  "Type": "タイプ",
  "Spare sensor until": "予備センサー",
  "Spare parts until": "予備部品",
  "Filter": "フィルター",
  "Check all": "すべてチェック",
  "Order code": "注文コード",
  "Repair until": "修理期間",
  "Tag": "タグ",
  "Ok": "オッケー",
  "Category code": "カテゴリーコード",
  "Phase out": "フェーズアウト",
  'Compatibility advices': '追加ドキュメント',
  'Co.': '追加資料',
} as LocalizedDictionary;
